namespace advisorop.components.meetinghub {
    export class MSGraphCalendarsController {
        calendars: Array<domains.ICalendar>;

        constructor(private meetingHubService: services.MeetingHubService) {

        }

        $onInit(): void {
        }

    }

    class MSGraphCalendars implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                calendars: "="
            };
            this.controller = [`meetingHubService`, MSGraphCalendarsController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/meeting-hub-module/components/ms-graph-calendars.html`;
        }
    }
        angular.module(Constants.APP).component(`msGraphCalendars`, new MSGraphCalendars());
}